// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.support-us-out-button {
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 20px;
  cursor: pointer;
  position: absolute;
  right: 12px;
}
.support-us-need-help,
.support-us-log-out {
  min-width: 60px;
  margin-right: 20px;
}
.support-us-info {
  margin-top: 10px;
  height: 330px;
}
.support-dialog-list {
  font-size: 15px;
  line-height: 18px;
  opacity: 1;
  margin: 12px;
  min-height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/supportDialog/supportDialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".support-us-out-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  bottom: 20px;\n  cursor: pointer;\n  position: absolute;\n  right: 12px;\n}\n.support-us-need-help,\n.support-us-log-out {\n  min-width: 60px;\n  margin-right: 20px;\n}\n.support-us-info {\n  margin-top: 10px;\n  height: 330px;\n}\n.support-dialog-list {\n  font-size: 15px;\n  line-height: 18px;\n  opacity: 1;\n  margin: 12px;\n  min-height: 80px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
